import Component from '@glimmer/component';

import DOMPurify from 'dompurify';

interface Args {
	content?: string;
	extraClass?: string;
}

export default class CommonHtmlContainerComponent extends Component<Args> {
	get content() {
		return DOMPurify.sanitize(this.args.content || '');
	}
	<template>
		<div class={{@extraClass}}>
			{{{this.content}}}
		</div>
	</template>
}
